import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";
import Dashboard from "@/pages/Dashboard";
import EmpresaDetalhe from "@/pages/EmpresaDetalhe";
import ContadorPortal from "@/pages/ContadorPortal";

function App() {
  return (
    <div className="App">
      <Toaster position="top-right" richColors />
      <BrowserRouter basename="/sintegra">
        <Routes>
          <Route path="/" element={<Dashboard />} />
          <Route path="/empresa/:id" element={<EmpresaDetalhe />} />
          <Route path="/contador/:token" element={<ContadorPortal />} />
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;
